import React from 'react';

function Accessibility() {
  return (
    <section className="page-content">
      <h1 className="page-title">הצהרת נגישות</h1>
      
      <div className="content-section">
        <h2>מחויבות לנגישות</h2>
        <p>
          מרפאת דר אליהו פישר מחויבת לספק שירותים נגישים ושוויוניים לכלל הלקוחות, 
          כולל אנשים עם מוגבלויות, בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות, התשנ"ח-1998, 
          ולתקן הישראלי 5568 להנגשת אתרי אינטרנט.
        </p>
        
        <h2>רמת הנגישות</h2>
        <p>
          האתר עומד בדרישות תקן ישראלי 5568, המבוסס על הנחיות WCAG 2.0 ברמה AA. 
          האתר כולל את המאפיינים הבאים:
        </p>
        <ul style={{ marginRight: '20px', marginTop: '15px', marginBottom: '15px' }}>
          <li>ניווט נגיש באמצעות מקלדת עם אינדיקטורי מיקוד נראים</li>
          <li>תמיכה מלאה בקוראי מסך עם תכונות ARIA</li>
          <li>ניגודיות צבעים מותאמת העומדת בתקן WCAG AA (4.5:1 לטקסט רגיל, 3:1 לטקסט גדול)</li>
          <li>טקסטים חלופיים (alt) לכל התמונות</li>
          <li>מבנה HTML סמנטי עם ARIA landmarks</li>
          <li>תמיכה בהגדלת טקסט באמצעות יחידות יחסיות</li>
          <li>ניווט ברור ועקבי עם סימון עמוד פעיל</li>
        </ul>
        
        <h2>חלקים נגישים באתר</h2>
        <p>האתר כולל את המאפיינים הנגישים הבאים:</p>
        <ul style={{ marginRight: '20px', marginTop: '15px', marginBottom: '15px' }}>
          <li>קישור לדילוג לתוכן הראשי בכל עמוד עם אינדיקטור מיקוד נראה</li>
          <li>ניווט נגיש בתפריט הראשי עם ARIA labels ו-aria-current לזיהוי עמוד פעיל</li>
          <li>תוויות ברורות לכל שדות הטופס</li>
          <li>הודעות שגיאה ברורות בעברית המקושרות לשדות באמצעות aria-describedby</li>
          <li>אינדיקטורי מיקוד נראים (outline) על כל האלמנטים האינטראקטיביים</li>
          <li>כפתורים עם מצב disabled מוגדר עם אינדיקטור ויזואלי ברור</li>
          <li>אזורי ARIA live להודעות דינמיות (שליחת טופס, שגיאות)</li>
          <li>תמיכה מלאה בכיוון RTL (מימין לשמאל)</li>
          <li>עיצוב רספונסיבי המתאים למכשירים שונים</li>
        </ul>
        
        <h2>חלקים שעדיין לא נגישים</h2>
        <p>
          אנו עובדים באופן מתמיד על שיפור הנגישות באתר. 
          במידה ונתקלתם בבעיית נגישות, נשמח לקבל את פנייתכם.
        </p>
        
        <h2>דרכי פנייה</h2>
        <p>
          במידה ונתקלתם בבעיית נגישות או שיש לכם הצעות לשיפור, 
          ניתן לפנות אלינו בדרכים הבאות:
        </p>
        <div style={{ marginTop: '20px', padding: '20px', backgroundColor: '#f5f5f0', borderRadius: '8px' }}>
          <p><strong>דואר אלקטרוני:</strong> <a href="mailto:dr.fisher.endo@gmail.com">dr.fisher.endo@gmail.com</a></p>
          <p><strong>טלפון:</strong> <a href="tel:0523254522">052-325-4522</a></p>
          <p><strong>כתובת:</strong> פרדס חנה כרכור, דרך הים 34 א</p>
        </div>
        
        <h2>רכז נגישות</h2>
        <p>
          רכז הנגישות של המרפאה זמין לקבלת פניות בנושא נגישות. 
          נשמח לסייע ולשפר את חוויית השימוש באתר עבור כל המשתמשים.
        </p>
        
        <h2>עדכון הצהרת הנגישות</h2>
        <p>
          הצהרת נגישות זו עודכנה לאחרונה ב-{new Date().toLocaleDateString('he-IL', { year: 'numeric', month: 'long', day: 'numeric' })}. 
          אנו מתחייבים לעדכן את ההצהרה באופן שוטף בהתאם לשיפורים הנעשים באתר.
        </p>
        
        <h2>מידע נוסף</h2>
        <p>
          למידע נוסף על נגישות באינטרנט, ניתן לעיין באתר נציבות שוויון זכויות לאנשים עם מוגבלות 
          ובתקן הישראלי 5568 להנגשת אתרי אינטרנט.
        </p>
      </div>
    </section>
  );
}

export default Accessibility;

